import { CommonModule } from '@angular/common';
import { ChangeDetectionStrategy, ChangeDetectorRef, Component } from '@angular/core';
import type { ClientFindInterface } from '@zaoblako/shared/modules/client/dtos/client/client-find.dto';
import type { HelpdeskPartialUpdateFormInterface } from '@zaoblako/shared/modules/helpdesk/dto/helpdesk-partial-update-form.dto';
import type { ExternalUserFindInterface } from '@zaoblako/shared/modules/security/dtos/external-user/external-user-find.dto';
import { HelpDeskTaskService } from '@zaoblako/web/core/services/helpdesk/help-desk-task.service';
import { ExternalUserService } from '@zaoblako/web/core/services/security/external-user.service';
import { ClientAutoCompleteComponent } from '@zaoblako/web/shared/dumbs/autoComplete/client-auto-complete/client-auto-complete.component';
import { SingleSelectComponent } from '@zaoblako/web/shared/dumbs/dropdowns/single-select/single-select.component';
import { SpinnerComponent } from '@zaoblako/web/shared/dumbs/spinner/spinner.component';
import { SharedModule } from 'primeng/api';
import { ButtonModule } from 'primeng/button';
import { DynamicDialogConfig, DynamicDialogRef } from 'primeng/dynamicdialog';
import { MessagesModule } from 'primeng/messages';
import { of, switchMap } from 'rxjs';

@Component({
  selector: 'crm-change-client-helpdesk-modal',
  standalone: true,
  imports: [
    CommonModule,
    SingleSelectComponent,
    SpinnerComponent,
    ButtonModule,
    ClientAutoCompleteComponent,
    MessagesModule,
    SharedModule
  ],
  templateUrl: './change-client-helpdesk-modal.component.html',
  changeDetection: ChangeDetectionStrategy.OnPush
})
export class ChangeClientHelpdeskModalComponent {
  public loading = false;
  public taskId: number;

  public client: ClientFindInterface;
  public externalUser: ExternalUserFindInterface;

  public constructor(
    private readonly externalUserService: ExternalUserService,
    private readonly helpDeskTaskService: HelpDeskTaskService,
    public readonly ref: DynamicDialogRef,
    private readonly config: DynamicDialogConfig,
    private readonly cdRef: ChangeDetectorRef
  ) {
    this.client = config.data.client;
    this.externalUser = config.data.externalUser;
    this.taskId = config.data.taskId;
  }

  public save() {
    if (this.client?.id) {
      this.loading = true;
      this.cdRef.markForCheck();

      this.helpDeskTaskService
        .patch(<HelpdeskPartialUpdateFormInterface & { id?: number }>{
          id: this.taskId,
          client: this.client
        })
        .pipe(
          switchMap(() =>
            this.externalUser
              ? this.externalUserService.patch({
                  id: this.externalUser?.id,
                  client: this.client
                })
              : of([])
          )
        )
        .subscribe(() => {
          this.ref?.close({
            client: this.client,
            externalUser: this.externalUser,
            isShowClientModal: false
          });
          this.loading = false;
          this.cdRef.markForCheck();
        });
    }
    this.ref?.close({
      client: this.client,
      isShowClientModal: false
    });
  }
}
